export const flattenArrayOfLessonPdfs = lessons => {
  const flattenedLessons = lessons.flat(2).reduce((results, lesson) => {
    if (lesson) {
      const lessonPdf = {
        displayTitle: lesson.displayTitle,
        href:
          lesson.file?.url ||
          lesson.file?.file?.url ||
          lesson.file?.file?.upload,
      }
      const dataExists = lessonPdf.displayTitle && lessonPdf.href

      dataExists && results.push(lessonPdf)
    }

    return results
  }, [])

  return flattenedLessons
}

export const resolveLessonSlug = ({ contentfulLesson, lessonIndex }) => {
  const routeSlug =
    contentfulLesson?.routeSlug ||
    contentfulLesson?.route_slug ||
    contentfulLesson?.route

  if (typeof routeSlug === 'string' && routeSlug.trim()) {
    return routeSlug
  }

  return `lesson-${String(lessonIndex).padStart(2, '0')}`
}
